<script>
    import Navbar from './navbar.svelte'
    import PhoneInfo from './phone-info.svelte'
    import TabBar from './tab-bar.svelte'
    import TopText from './top-text.svelte'
    import Selector from './selector.svelte'
    import LinkIcons from './link-icons.svelte'
    import BottomButtonBar from '../shared/bottom-button-bar.svelte'

    export let theme
    export let primary
    export let tertiary
    export let secondary
    export let rowIconColor
    export let tabBarHighlightTextColor

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    $: backgroundImage = `${staticAssetPrefix}img/onboarding/${
        theme === true ? 'event-background-dark.png' : 'event-background.png'
    }`
</script>

<style>
    .fno-preview {
        width: 414px;
        height: 896px;
        position: relative;
        margin-bottom: 25px;
    }
</style>

<div class="fno-preview" style="background-image: url({backgroundImage});">
    <Navbar fill={primary} />
    <PhoneInfo />
    <TabBar fill={tertiary} />
    <Selector fill={secondary} />
    <TopText textFill={tabBarHighlightTextColor} />
    <LinkIcons fill={rowIconColor}  />
    <BottomButtonBar fill={primary} />
</div>
